<template>
  <el-dialog
    v-if="showGrantPopup"
    :visible.sync="showGrantPopup"
    width="440px"
    :show-close="false"
    append-to-body
    class="prop-grant-dialog"
    :close-on-click-modal="true"
    :top="'18vh'"
  >
    <span class="custom-close" @click="showGrantPopup = false">
      <i class="el-icon-close"></i>
    </span>
    <div class="popup-bg"></div>
    <div class="popup-header">
      <span class="popup-icon">🎉</span>
      <span class="popup-title">恭喜你获得新道具</span>
      <div class="popup-desc">快来领取你的专属奖励吧！</div>
    </div>
    <div v-if="pendingGrants.length > 0" class="prop-list">
      <div
        v-for="grant in pendingGrants"
        :key="grant.id"
        class="prop-card"
        :class="{ 'disabled': grant.grantNum - grant.receivedNum <= 0 }"
      >
        <div class="prop-icon-bg">
          <span class="prop-icon">{{ getPropIcon(grant.propId) }}</span>
        </div>
        <div class="prop-info">
          <div class="prop-name">{{ getPropName(grant.propId) }}</div>
          <div class="prop-desc">{{ getPropDesc(grant.propId) }}</div>
        </div>
        <div class="prop-action">
          <el-badge :value="'剩余' + (grant.grantNum - grant.receivedNum) + '张'" class="prop-badge" v-if="grant.grantNum - grant.receivedNum > 0">
            <el-button
              type="primary"
              size="mini"
              class="receive-btn"
              :disabled="grant.grantNum - grant.receivedNum <= 0"
              @click="handleReceiveGrant(grant.id)"
            >立即领取</el-button>
          </el-badge>
          <span class="prop-qty" v-else>已领完</span>
        </div>
      </div>
    </div>
    <div v-else class="no-prop">
      <i class="el-icon-present"></i> 暂无可领取道具
    </div>
  </el-dialog>
</template>

<script>
import { getPendingGrant, receiveGrant } from '@/api/propGrant'

export default {
  name: 'PropGrantPopup',
  data() {
    return {
      showGrantPopup: false,
      pendingGrants: [],
      timer: null,
      lastGrantIds: ''
    }
  },
  computed: {
    userId() {
      const user = this.$store.state.userInfo
      return user ? (user.id || user.userId) : null
    }
  },
  watch: {
    userId(newVal) {
      if (newVal) {
        this.tryPopup()
      }
    }
  },
  created() {
    if (this.userId) {
      this.tryPopup()
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  },
  methods: {
    tryPopup() {
      this.fetchPendingGrant()
      if (!this.timer) {
        this.timer = setInterval(this.fetchPendingGrant, 60000)
      }
    },
    fetchPendingGrant() {
      if (!this.userId) return
      getPendingGrant(this.userId).then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          const ids = res.data.map(item => item.id).join(',')
          if (ids !== this.lastGrantIds) {
            this.pendingGrants = res.data
            this.showGrantPopup = true
            this.lastGrantIds = ids
          }
        } else {
          this.showGrantPopup = false
          this.lastGrantIds = ''
        }
      })
    },
    handleReceiveGrant(grantId) {
      receiveGrant(this.userId, grantId).then(res => {
        if (res.code === 200) {
          this.$message.success('领取成功')
          this.fetchPendingGrant()
        } else {
          this.$message.error(res.message || '领取失败')
        }
      })
    },
    getPropName(propId) {
      const map = {
        1: '补签卡', 2: '积分卡', 3: '优惠卷', 4: '置顶卡', 5: '评论置顶卡',
        6: 'VIP体验卡', 7: '内容推广卡', 8: '隐身卡'
      }
      return map[propId] || '未知道具'
    },
    getPropIcon(propId) {
      const map = {
        1: '🗓️', 2: '💎', 3: '🎫', 4: '🌟', 5: '📌',
        6: '👑', 7: '🚀', 8:  '👻'
      }
      return map[propId] || '🎁'
    },
    getPropDesc(propId) {
      const map = {
        1: '补签一次，连续签到不中断', 2: '积分奖励，兑换好礼', 3: '优惠券，购物更省钱',
        4: '置顶卡，内容首页推荐', 5: '评论置顶，优先曝光',
        6: 'VIP体验，尊享特权', 7: '内容推广，更多人看到你',
        8: '隐身卡，悄悄访问'
      }
      return map[propId] || '专属道具，快来体验'
    }
  }
}
</script>

<style>
.prop-grant-dialog .el-dialog__wrapper,
.prop-grant-dialog .el-dialog {
  box-shadow: none !important;
}
.prop-grant-dialog .el-dialog__body,
.prop-grant-dialog .el-dialog {
  background: var(--card-bg) !important;
}
.prop-grant-dialog .el-dialog__body {
  border-radius: 32px !important;
}
.prop-grant-dialog .el-dialog {
  border-radius: 32px !important;
}
.prop-grant-dialog .el-dialog__header {
  display: none !important;
}
.prop-grant-dialog .el-dialog__headerbtn {
  display: none !important;
}
.custom-close {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: rgba(0,0,0,0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 20;
  transition: background 0.2s;
}
.custom-close:hover {
  background: #409EFF;
}
.custom-close .el-icon-close {
  color: #888;
  font-size: 22px;
  font-weight: bold;
  transition: color 0.2s;
}
.custom-close:hover .el-icon-close {
  color: #fff;
}
body[data-theme='deep'] .custom-close {
  background: rgba(255,255,255,0.08);
}
body[data-theme='deep'] .custom-close .el-icon-close {
  color: #bbb;
}
body[data-theme='deep'] .custom-close:hover {
  background: #6cb4ff;
}
body[data-theme='deep'] .prop-grant-dialog .el-dialog {
  border-radius: 32px !important;
  overflow: hidden !important;
  background: #23272f !important;
  box-shadow: none !important;
}
body[data-theme='deep'] .prop-grant-dialog .el-dialog__body {
  border-radius: 32px !important;
  background: #23272f !important;
}
body[data-theme='deep'] .prop-grant-dialog .popup-bg {
  border-radius: 32px !important;
  overflow: hidden !important;
}
body[data-theme='deep'] .prop-grant-dialog .prop-card {
  background: #23272f !important;
  color: #eee;
  box-shadow: 0 2px 16px #181a1b !important;
}
body[data-theme='deep'] .prop-grant-dialog .popup-title {
  color: #6cb4ff;
}
body[data-theme='deep'] .prop-grant-dialog .prop-name {
  color: #6cb4ff;
}
.popup-bg {
  position: absolute;
  left: 0; top: 0; right: 0; bottom: 0;
  opacity: 0.25;
  z-index: 0;
}
.popup-header {
  text-align: center;
  padding: 32px 0 16px 0;
  position: relative;
  z-index: 1;
}
.popup-icon {
  font-size: 38px;
  display: block;
  margin-bottom: 6px;
  animation: tada 1.2s;
}
@keyframes tada {
  0% { transform: scale(1);}
  10%, 20% { transform: scale(0.9) rotate(-3deg);}
  30%, 50%, 70%, 90% { transform: scale(1.1) rotate(3deg);}
  40%, 60%, 80% { transform: scale(1.1) rotate(-3deg);}
  100% { transform: scale(1);}
}
.popup-title {
  font-size: 24px;
  font-weight: bold;
  color: #409EFF;
  letter-spacing: 1px;
}
.popup-desc {
  color: #888;
  font-size: 15px;
  margin-top: 6px;
}
.prop-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 12px;
}
.prop-card {
  display: flex;
  align-items: center;
  background: var(--card-bg) !important;
  border-radius: 12px;
  box-shadow: 0 2px 16px #e6e6e6;
  padding: 16px 20px;
  transition: box-shadow 0.2s, opacity 0.2s, transform 0.2s;
  position: relative;
}
.prop-card:hover {
  box-shadow: 0 6px 24px #d0e2ff;
  transform: translateY(-2px) scale(1.03);
}
.prop-card.disabled {
  opacity: 0.5;
  filter: grayscale(0.7);
}
.prop-icon-bg {
  width: 48px; height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #e3f0ff 60%, #fff 100%);
  display: flex; align-items: center; justify-content: center;
  margin-right: 16px;
  box-shadow: 0 2px 8px #e6e6e6;
}
.prop-icon {
  font-size: 28px;
}
.prop-info {
  flex: 1;
}
.prop-name {
  font-weight: bold;
  color: #409EFF;
  font-size: 17px;
}
.prop-desc {
  color: #888;
  font-size: 13px;
  margin-top: 2px;
}
.prop-action {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}
.prop-badge {
  margin-bottom: 4px;
}
.prop-qty {
  color: #bbb;
  font-size: 13px;
}
.receive-btn {
  font-weight: bold;
  border-radius: 18px;
  padding: 6px 22px;
  background: linear-gradient(90deg, #409EFF 60%, #67c23a 100%);
  color: #fff;
  border: none;
  box-shadow: 0 2px 8px #e3f0ff;
  transition: background 0.2s, box-shadow 0.2s;
}
.receive-btn:hover {
  background: linear-gradient(90deg, #67c23a 60%, #409EFF 100%);
  box-shadow: 0 4px 16px #b2e5c7;
}
.no-prop {
  text-align: center;
  color: #bbb;
  font-size: 16px;
  padding: 40px 0 10px 0;
}
</style>